import * as R from 'ramda';
// constants
import { DEFAULT_DATE_TIME_FORMAT } from '../../../constants';
// utilities
import {
  isTrue,
  isFalse,
  getTranslation,
  getDateWithFormat,
} from '../../../utilities';
// ui
import {
  Box,
} from '../../../ui';
////////////////////////////////////////////////

const BooleanCell = ({ data, path }) => {
  let value = '';
  const booleanValue = R.path(path, data);

  if (isTrue(booleanValue)) {
    value = getTranslation('labels.yes', 'Yes');
  }

  if (isFalse(booleanValue)) {
    value = getTranslation('labels.no', 'No');
  }

  return <Box title={value}>{value}</Box>;
};

const DateCell = ({ data, path }) => {
  let formatted = '';
  const date = R.path(path, data);
  const value = getDateWithFormat(date, DEFAULT_DATE_TIME_FORMAT);

  if (R.equals(value, 'Invalid Date')) {
    formatted = '';
  } else {
    formatted = value;
  }

  return <Box title={formatted}>{formatted}</Box>;
};

export {
  DateCell,
  BooleanCell,
};
